<template>
  <button
    type="button"
    class="btn-action"
    :class="{ 'btn-action--image-only': imageSrc }"
    @click="$emit('click', $event)"
  >
    <span v-if="imageSrc" class="btn-action__icon">
      <img :src="imageSrc" :alt="label" class="btn-action__img" />
    </span>
    <span v-else-if="$slots.icon" class="btn-action__icon">
      <slot name="icon" />
    </span>
    <span v-if="!imageSrc" class="btn-action__label">{{ label }}</span>
  </button>
</template>

<script>
export default {
  name: "ActionButton",
  props: {
    label: {
      type: String,
      required: true,
    },
    imageSrc: {
      type: String,
      default: "",
    },
  },
};
</script>

<style scoped>
.btn-action {
  flex: 1;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 10px;
  gap: 10px;
  height: 40px;
  background: #00b14d;
  border-radius: 12px;
  border: none;
  font-weight: 700;
  font-size: 18px;
  line-height: 27px;
  color: #ffffff;
  cursor: pointer;
  transition: all 0.3s;
}

.btn-action__icon {
  width: 20px;
  height: 20px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.btn-action__icon >>> svg {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
}

.btn-action--image-only {
  padding: 0;
  background: transparent;
  gap: 0;
  height: auto;
  align-items: stretch;
}

.btn-action--image-only .btn-action__icon {
  width: 100%;
  display: block;
  line-height: 0;
}

.btn-action--image-only .btn-action__img {
  width: 100%;
  height: auto;
  display: block;
  vertical-align: top;
}

.btn-action:active {
  background: #009940;
}

@media screen and (max-width: 375px) {
  .btn-action {
    font-size: 14px;
  }
}
</style>
